/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import cn from 'classnames';

import { LanguageKeyEnum } from '@kaltura-ott/tvpil-shared';

import { useAppStore, useOnClickOutside } from 'hooks';

import LanguagesList from '../../presenters/LanguagesList/LanguagesList';

import styles from './LanguagesDropDown.module.scss';

function LanguagesDropDown() {
  const {
    appStore: {
      localizationStore: { languageListForKey, displayLanguage, languageNativeNameByCode, languagesList },
    },
  } = useAppStore();
  const intl = useIntl();
  const [list, setList] = useState([{ code: 'en', nativeName: 'English', isDefault: true }]);
  const [opened, setOpened] = useState(false);
  const [languageValue, setLanguage] = useState('');
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (languagesList.length) {
      setList(languageListForKey(LanguageKeyEnum.display));
      setLanguage(displayLanguage);
    }
  }, []); // eslint-disable-line

  useOnClickOutside(ref, () => setOpened(false));

  function toggleList() {
    setOpened(!opened);
  }

  return (
    <div ref={ref} className={styles.wrapper}>
      <button
        aria-label={intl.formatMessage({ defaultMessage: 'language list', id: 'General.Button.LanguageList' })}
        className={styles.current}
        onClick={toggleList}
        type='button'
        tabIndex={0}
      >
        <span className={styles.earth} />
        <span>{languageNativeNameByCode(languageValue)}</span>
        <span className={cn(styles.switcher, opened && styles.opened)} />
      </button>
      <div className={cn(styles.list, opened && styles.show)} onClick={toggleList} >
        <LanguagesList defaultValue={languageValue} isDropDown list={list} type='display' />
      </div>
    </div>
  );
}

export default LanguagesDropDown;
